// Virtual (simulated) drones an operator creates from the UI (issue #322).
// Shape mirrors the backend Drone response for the /api/v1/drones/virtual routes.

export interface VirtualDrone {
  id: string;
  hardware_id: string;
  /** The drone's own name (#406); omitted when it was created without one. */
  name?: string;
  status: string;
  device_model?: string;
  virtual: boolean;
  metadata?: {
    owner_id?: string;
    custom_fields?: Record<string, unknown> | null;
  };
  created_at: string;
}

export interface VirtualDroneListResponse {
  drones: VirtualDrone[];
  total: number;
}

/**
 * Pilot-facing display name: the name they gave it, else its id.
 *
 * The drone's own `name` since #406. It used to be read out of
 * `custom_fields`, where the server no longer puts it.
 */
export const virtualDroneName = (d: VirtualDrone): string => d.name ?? d.id;
